<template>
    <div class="container">
        <p class="reader-disclaimer ml-auto col-12 col-lg-10 mr-auto">
            <strong>Just so you know.</strong> The 'Listen' and 'Read' versions of each Book Insight differ slightly. The 'Read' version is not a transcript of the audio, and often has extra info.
        </p>
        <div id="theme-block-container" class="theme-block-container ml-auto col-12 col-lg-10 mr-auto">
            <template v-if="isFreemiumBiLocked">
                <reader-theme
                    :theme="readerThemes[0]"
                    :index="0"
                    :theme-font-styles="themeFontStyles"
                    class="is-freemium"
                />
                <card-box id="signup-wall">
                    <template #body>
                        <div class="row">
                            <div class="col-12 col-md-6 track-to-learning">
                                <h1>Stay on the fastest track to learning.</h1>
                                <p>You’ve made it to the end of your Insights preview. Please sign in or sign up for a free Insights account, and you’ll get to continue enjoying key takeaways from the best nonfiction. </p>
                                <img
                                    class="d-none d-md-block"
                                    srcset="@assets/img/book-insights/on-the-go-people.jpg 1x, @assets/img/book-insights/on-the-go-people-2x.jpg 2x"
                                    src="@assets/img/book-insights/on-the-go-people.jpg"
                                    alt="People graphic"
                                >
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="auth-form">
                                    <insights-sign-up-landing-form :use-route-handler="false" @auth-sucessfull="authSucessfull" />
                                </div>
                            </div>
                        </div>
                    </template>
                </card-box>
            </template>
            <template v-else>
                <reader-theme
                    v-for="(theme, index) in readerThemes"
                    :key="theme.id"
                    :index="index"
                    :theme="theme"
                    :theme-font-styles="themeFontStyles"
                />
            </template>
        </div>
        <div class="ql-editor media-reference ml-auto col-12 col-lg-10 mr-auto">
            <div v-html="mediaReferences" />
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "ReaderThemes",
    components: {
        readerTheme: () => import(/* webpackChunkName: "reader-theme"*/ "./theme"),
        insightsSignUpLandingForm: () => import(/* webpackChunkName: "insights-sign-up-landing-form"*/ "@c/auth/sign-up/insights-landing")
    },
    props: {
        mediaReferences: {
            type: String,
            default: ""
        },
        themeFontStyles: {
            type: Object,
            required: true
        },
        isFreemiumBiLocked: {
            type: Boolean,
            default: false
        }
    },
    computed:{
        ...mapState({
            readerThemes: state => state.NonfictionReader.readerThemes
        })
    },
    methods: {
        authSucessfull(user, includeUserInNewsletter = false) {
            console.log(user);
            console.log(includeUserInNewsletter);
            console.log("Sign up sucess");
        }
    }
}
</script>

<style lang="scss">
.reader-disclaimer {
    margin-top: 20px;
    margin-bottom: 0;
    font-size: 12px;
    line-height: normal;
    color: white;
}

.theme-block-container {
    .theme-block {
        .title {
            color: white;
            font-size: 32px;
            font-weight: 500;
            line-height: 43px;
            margin-bottom: 30px;
        }

        &:first-child {
            .title {
                margin-bottom: 60px;
            }
        }

        .author {
            color: $medium-gray;
            font-size: 26px;
            font-weight: 600;
            line-height: 36px;
            margin-bottom: 40px;
        }

        &.is-freemium {
            overflow: hidden;
            height: 700px;
            position: relative;

            &::after {
                content: "";
                position: absolute;
                width: 100%;
                bottom: 0;
                height: 200px;
                background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
            }
        }

    }

    .card {
        margin-top: 25px;
        margin-bottom: 50px;
        padding: 25px 35px;
        box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.24);

        @media (max-width: $md) {
            padding: 25px 15px;
            margin-left: -15px;
            margin-right: -15px;
        }

        .track-to-learning {
            padding: 25px 35px;

            @media (max-width: $lg) {
                padding: 0 15px;
            }

            h1 {
                font-size: 32px;
                font-weight: 600;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.06;
                letter-spacing: -0.77px;
                color: $secondary-color;
                margin-bottom: 25px;

                @media (max-width: $md) {
                    font-size: 28px;
                    font-weight: 600;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.21;
                    letter-spacing: -0.68px;
                }
            }

            p {
                font-size: 18px;
                font-weight: 600;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.56;
                letter-spacing: -0.43px;
                color: #666666;
                margin-bottom: 40px;

                @media (max-width: $md) {
                    font-size: 16px;
                    font-weight: 600;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 1.75;
                    letter-spacing: -0.39px;
                    margin-bottom: 25px;
                }
            }
        }

        .auth-form {
            margin: 0 auto;
            box-shadow: none !important;
            width: initial;

            form {
                padding: 0;


                .form-check {
                    margin-bottom: 30px;
                }

                .log-in-link {
                    margin-top: 20px;
                }

                button {
                    height: 52px;
                }

                .terms-conditions {
                    margin: 0 auto;
                    margin-top: 20px;
                    width: 80%;
                }

                .facebook-signup {
                    border: 1px solid #3C5A99;
                    color: #3C5A99 !important;
                    background-color: transparent !important;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
    }

}
</style>

<style lang="scss" scoped>
.media-reference {
    margin-top: 25px;

    /deep/ *:not(a) {
        color: white !important;
        background-color: transparent !important;
    }

    /deep/ a {
        color: #FEC72E !important;
    }
}
.container {
    margin-bottom: 75px;
}
</style>
